import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { getBackendURL } from '../../utils/backendURL';

export default function OpsPasswordRecovery({ user }) {
  const [permissions, setPermissions] = useState(null);
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [attempt, setAttempt] = useState(0);
  const url = `${getBackendURL()}/api/ops/users/${encodeURIComponent(user.id)}/password-recovery`;
  const headers = { Authorization: `Bearer ${localStorage.getItem('admin_token')}` };
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    axios.get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` }, signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setPermissions(data); })
      .catch(() => { if (!controller.signal.aborted) setError('Could not check recovery permissions.'); });
    return () => controller.abort();
  }, [url, attempt]);
  const send = async () => {
    setSending(true); setError(''); setMessage('');
    try {
      await axios.post(url, {}, { headers });
      setMessage(`Recovery email accepted for ${user.email}. The link expires in one hour.`);
      setOpen(false);
    } catch (failure) {
      setError(failure.response?.data?.detail || 'Could not request recovery. Please retry.');
    } finally { setSending(false); }
  };
  return <section className="border-t pt-4 space-y-3" aria-label="Password recovery">
    <h3 className="font-semibold">Password recovery</h3>
    <p className="text-sm text-gray-600">Send a recovery link to the user’s registered email. Their password stays unchanged until they use the link.</p>
    {!permissions && !error && <p role="status">Checking permissions…</p>}
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {!permissions && error && <button onClick={() => setAttempt(value => value + 1)}>Retry permissions</button>}
    {permissions && !permissions.can_request && <p className="text-sm text-gray-500">Your OPS role has read-only access to password recovery.</p>}
    {permissions?.can_request && !permissions.account_active && <p className="text-sm text-gray-500">Activate this account before requesting recovery.</p>}
    {permissions?.can_request && permissions.account_active && <button onClick={() => { setError(''); setOpen(true); }}
      disabled={sending} className="px-4 py-2 rounded-lg bg-blue-600 text-white disabled:opacity-50">Send password reset email</button>}
    {message && <p role="status" className="text-green-700">{message}</p>}
    <Dialog open={open} onOpenChange={value => { if (!sending) setOpen(value); }}>
      <DialogContent className="bg-white text-gray-900">
        <DialogHeader><DialogTitle>Send password reset email?</DialogTitle>
          <DialogDescription>The link will be sent only to {user.email}. It expires in one hour.</DialogDescription></DialogHeader>
        {error && <p role="alert" className="text-red-700">{error}</p>}
        <div className="flex justify-end gap-3">
          <button disabled={sending} onClick={() => setOpen(false)}>Cancel</button>
          <button disabled={sending} onClick={send} className="rounded bg-blue-600 px-4 py-2 text-white disabled:opacity-50">
            {sending ? 'Sending…' : 'Confirm send'}</button>
        </div>
      </DialogContent>
    </Dialog>
  </section>;
}
